const getDate = (date, options = {}) => {
  let parsedDate = date;
  if (!parsedDate) return undefined;
  if (options.split) {
    const [year, month, day] = parsedDate.split('-').map(Number);
    return new Date(year, month - 1, day).toLocaleDateString('pt-br');
  }

  return new Date(parsedDate)
    .toLocaleDateString('pt-br');
};

export { getDate };
